import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';
import { Btn, Label } from 'components';
import GrayArrow from 'assets/img/common/ic_right_arrow_gray.svg';
import BlueArrow from 'assets/img/common/ic_right_arrow_blue.svg';

export const BtnService = styled(Btn)`
    padding: 16px 20px;
    min-height: 84px;
    height: 100%;
    &:hover {
        background-color: ${palette('blue_opacity_100')};
        border-color: ${palette('blue_900')};
        ${props => {
        return css`
                ${ArrowIcon} {
                    background-image: url('${BlueArrow}');
                }

                ${LabelContainer} {
                    > label {
                        color: ${palette('blue_900')};
                    }
                }
            `
    }}
    }
`;

export const ChildrenContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const LabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: baseline;
    > label {
        pointer-events: none;
    }
`;

export const ArrowIcon = styled.div`
    margin-left: 12px;
    width: 12px;
    height: 12px;
    background-size: 12px 12px;
    background-image: url('${GrayArrow}');
`;

export const ServiceStatusWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const ServiceNameWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export interface ServiceStatusProps {
    type?: 'ACTIVE' | 'INACTIVE';
}

export const ServiceStatus = styled.div<ServiceStatusProps>`
    margin-left: 4px;
    padding: 2px 8px;
    border-radius: 10px;
    ${theme('fontStyle.caption_bold')}
    ${props => {
        switch (props.type) {
            case 'ACTIVE':
                return css`
                background-color: ${palette('blue_opacity_100')};
                color: ${palette('blue_900')};
                `;
            case 'INACTIVE':
                return css`
                background-color: ${palette('red_opacity_100')};
                color: ${palette('red_900')};
                `;
            default:
                return css`
                background-color: ${palette('gray_opacity_200')};
                color: ${palette('gray_opacity_600')};
                `;
        }
    }}
`;

export const LabelDescription = styled(Label)`
    text-align: start;
`;